import React, { useState, useEffect } from "react";
import { Card, Grid, Sticky, Button, Icon, Modal, Form, Dimmer, Loader } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Events.css";
import "../css/RSO.css";
import "../css/MyRSOs.css";
import "../css/UniversityInfo.css";

export default function MyRSOs() {
    const[open, setOpen] = useState(false);
    const[createError, setCreateError] = useState([]);
    const[RSOName, setRSOName] = useState("");
    const[description, setDescription] = useState("");
    const [ownedRSOList, setOwnedRSOList] = useState([]);
    const [joinedRSO, setJoinedRSOList] = useState([]);
    const [updateCheck, setUpdateCheck] = useState(0);
    const [displayCreateEvent, setDisplayCreateEvent] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        console.log(localStorage.getItem('uniid'));
        handleGetOwnedRSOs();
        handleGetRSOJoined();
        console.log("all rso");
        console.log(ownedRSOList);
        console.log("joined rso");
        console.log(joinedRSO);
    }, []);

    useEffect(() => {
        handleGetOwnedRSOs();
        handleGetRSOJoined();
    }, [updateCheck]);

    useEffect(() => {
        handleDisplayCreateEvent();
        console.log(ownedRSOList);
    }, [ownedRSOList]);

    const handleDisplayCreateEvent = () => {
        if (ownedRSOList.length > 0)
        {
            ownedRSOList.forEach((RSO) => {
                if (RSO.approval === 1)
                {
                    setDisplayCreateEvent(true);
                    return
                }
            })
        }
    }

    const handleDescription = (e) => {
        setDescription(e.target.value);
        console.log(description);
    };

    const handleName = (e) => {
        setRSOName(e.target.value);
        console.log(RSOName);
    };

    const close = (e) => {
        setOpen(false);
        setCreateError("");
    };

    async function closeAndUpdate() {
        if (RSOName === "" || description === "")
        {
            setCreateError("Please Fill Out All Fields");
        }
        else {
            try {
                let info = {
                    adminid: localStorage.getItem("userid"),
                    name: RSOName,
                    description: description
                };

                let jsonObj = JSON.stringify(info);

                const response = await fetch(
                    "https://student-org-events.herokuapp.com/PHP/createRSO.php",
                    {
                        method: "POST",
                        body: jsonObj,
                        header: { "content-Type": "application/json" },
                    }
                );

                let res = await response.json();
                console.log("This is the response error for listOwnedRSOs: " + res.error);

                if (res.error === "") {
                    setUpdateCheck(updateCheck + 1);
                    setCreateError("");
                    setOpen(false);
                }
                else {
                    setCreateError(res.error);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectMyRSO = () => {
        navigate("/MyRSOs");
    };

    const redirectEvent = () => {
        navigate("/Events");
    };

    const redirectCreateEvent = () => {
        navigate("/CreateEvent");
    }

    async function handleGetRSOJoined() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listJoinedRSOs.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setJoinedRSOList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleGetOwnedRSOs() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listOwnedRSOs.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error for listOwnedRSOs: " + res.error);

            if (res.error === "") {
                setOwnedRSOList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleLeave = (event) => (e) => {
        handleLeaveHelper(event);
    };

    async function handleLeaveHelper(event) {
        try {
            let info = {
                rsoid: event.rsoid,
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/leaveRSO.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                alert(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem('first')}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectMyRSO}>My RSOs</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        <Icon className="event-icon" name='sign-out' size='large' />
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <div className = "events-top-section MyRSO-section-header">
                        <Grid
                            container
                            columns={2}
                            className="MyRSO-grid-card"
                        >
                            <Grid.Column className="MyRSO-header-col">
                                <h2 className="MyRSO-title">
                                    Owned RSOs:
                                </h2>
                            </Grid.Column>
                            <Grid.Column>
                                <Button className="MyRSO-button" onClick={() => setOpen(true)} >Create RSO</Button>
                                {displayCreateEvent && (<Button className="MyRSO-button" onClick={redirectCreateEvent} >Create Event</Button>)}
                                <Modal
                                dimmer = {'blurring'}
                                open = {open}
                                
                                //closeIcon
                                className='MyRSO-event-modal'
                                >
                                    <Modal.Header>Create Your RSO</Modal.Header>
                                    <Modal.Content>
                                        <div className='MyRSO-info-container'>
                                            <Form /*onSubmit={handleEditUni}*/>
                                                <div className="uniinfo-input">
                                                    <Form.Input
                                                    fluid
                                                    placeholder="Name of RSO"
                                                    required
                                                    onChange={handleName}
                                                    />
                                                </div>
                                                <div className="uniinfo-input">
                                                    <Form.TextArea
                                                    fluid
                                                    placeholder="RSO Description"
                                                    required
                                                    onChange={handleDescription}
                                                    />
                                                </div>
                                                <div className="login-error">
                                                    {createError !== "" ? createError : ""}
                                                </div>
                                                {/* <div className="uniinfo-button"> 
                                                    <Form.Button className="uniinfo-button">
                                                        FINISH
                                                    </Form.Button>
                                                </div>*/}
                                            </Form>
                                        </div>
                                    </Modal.Content>
                                    <Modal.Actions>
                                        <Button className="MyRSO-cancel-btn" onClick={() => close()}>Cancel</Button>
                                        <Button className="MyRSO-create-btn" onClick={() => closeAndUpdate()}>
                                            Create
                                        </Button>
                                    </Modal.Actions>
                                </Modal>
                            </Grid.Column>
                        </Grid>
                    </div>
                    <div className="events-event-cards-container">
                        {(ownedRSOList.length !== 0) ?
                        (ownedRSOList.map((event) => (
                            <div className="RSO-card-container">
                                {!ownedRSOList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={4}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Total Members:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                <b>{event.noStudents}</b>
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Status:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                <b>{(event.approval === 1) ? ("Approved") : ("Unapproved")}</b>
                                            </p>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                                ) : (<h3>No Owned RSOs</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                    <div className = "events-top-section MyRSO-section-header">
                        <Grid
                            container
                            columns={2}
                            className="MyRSO-grid-card"
                        >
                            <Grid.Column>
                                <h2 className="MyRSO-title">
                                    Joined RSOs:
                                </h2>
                            </Grid.Column>
                            <Grid.Column>
                                
                            </Grid.Column>
                        </Grid>
                    </div>
                    <div className="events-event-cards-container">
                        {(joinedRSO.length !== 0) ?
                        (joinedRSO.map((event) => (
                            <div className="RSO-card-container">
                                {!joinedRSO.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (!ownedRSOList.some(
                                (approvedEvent) =>
                                    approvedEvent.rsoid ===
                                    event.rsoid
                            ) ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={5}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Total Members:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                <b>{event.no_students}</b>
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Status:</u></b>
                                            </p>
                                            {(event.approval === 1) ? (
                                                <p className="MyRSO-description">
                                                    <b>Approved</b>
                                                </p>
                                            ) : (
                                                <p className="MyRSO-description" text-align="center">
                                                    <b>Unapproved</b>
                                                </p>
                                            )}
                                        </Grid.Column>
                                        <Grid.Column>
                                                <Button
                                                    className="MyRSO-approve-btn"
                                                    color="red"
                                                    size="massive"
                                                    onClick={handleLeave(event)}
                                                >
                                                    LEAVE RSO
                                                </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                            ):("")) : (<h3>No RSOs Joined</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                </div>
            </div>
        </div>
    );
}
